module.exports = __webpack_public_path__ + "7962a3935b42e2916a7ac123895157e2.MP3";